import { renderRichText } from '@storyblok/react';
import { Breadcrumbs } from '@/components/Shared/Breadcrumbs';
import { CTA } from '@/components/Shared/CTA/CallToAction';
import { FormattedText } from '@/components/Shared/FormattedText';
import { Container } from '@/components/Shared/Layout/Container';
import { isArrayWithValue } from '@/utils/helpers/isArrayWithValue';
import { isStringWithValue } from '@/utils/helpers/isStringWithValue';
import { IHeroBlok } from '@/utils/interfaces/bloks';
import { useEffect, useState } from 'react';

interface IProps {
  blok: IHeroBlok;
  isHome?: boolean;
}

export const HeroContent: React.FC<IProps> = ({ blok, isHome }) => {
  const headingClasses = ['text-inherit mb-0'];
  if (isHome) {
    headingClasses.push('text-7xl lg:text-8xl leading-snug');
  }

  const renderBodyContent = () => {
    if (!blok.body) return null;

    if (typeof blok.body === 'string') {
      return (
        <div className="mt-6 lg:text-lg xl:text-xl">
          {blok.body}
        </div>
      );
    }

    try {
      return (
        <div
          className="mt-6 lg:text-lg xl:text-xl richtext-content"
          dangerouslySetInnerHTML={{ __html: renderRichText(blok.body) }}
        />
      );
    } catch (error) {
      console.error('Error rendering richtext:', error);
      return null;
    }
  };

  return (
    <div className="w-full">
      <Container>
        <div className="py-6 lg:py-16 w-full pb-14 max-w-[500px]">
          {!isHome && <Breadcrumbs className="mb-3" />}
          {isStringWithValue(blok.heading) && (
            <div className="max-w-3xl">
              <FormattedText
                tag="h1"
                text={blok.heading}
                className={headingClasses.join(' ')}
              />
            </div>
          )}
          {renderBodyContent()}
          {isArrayWithValue(blok.cta) && blok.cta?.map ? (
            <div className="mt-6 lg:mt-10">
              <div className="flex flex-wrap gap-2">
                {blok.cta.map((cta, key) => (
                  <div className="inline-flex" key={key}>
                    <CTA blok={cta} />
                  </div>
                ))}
              </div>
            </div>
          ) : null}
        </div>
      </Container>
    </div>
  );
};